export const EMAIL_TEMPLATE_TYPES = {
  SEND_QUOTE: 'quote_send',
  ORDER_SHIPMENT: 'order_shipment',
  ORDER_REFUND: 'order_refund',
};

export const EMAIL_TEMPLATE_TYPE_LABELS: Record<
  (typeof EMAIL_TEMPLATE_TYPES)[keyof typeof EMAIL_TEMPLATE_TYPES],
  string
> = {
  [EMAIL_TEMPLATE_TYPES.SEND_QUOTE]: 'Quote-send',
  [EMAIL_TEMPLATE_TYPES.ORDER_SHIPMENT]: 'Order-shipment',
  [EMAIL_TEMPLATE_TYPES.ORDER_REFUND]: 'Order refund',
};
